import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
  width: 60vw;
  color: #303030;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 2.4vw);
  margin-top: 2.8vh;
  margin-left: 1.2vw;
  margin-right: 1.2vw;
  box-sizing: border-box;
`

export const HeaderText = styled.h2`
  font-size: 1.4vw;
  font-weight: 700;
  margin: 0;
  color: #303030;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;
  background-color: #eaeaea;
  color: #303030;
`

export const ContentContainer = styled.div`
  padding: 1.2vw;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  color: #303030;
`

export const Section = styled.div`
  background-color: #fff;
  padding: 1vh 0;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  color: #303030;

  &:not(:first-child) {
    border-top: 1px solid #e0e0e0;
    padding-top: 3vh;
  }
`

export const SectionHeader = styled.h3`
  font-size: 1vw;
  font-weight: 700;
  color: #303030;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3vh 2vw;
  color: #303030;
`

export const DetailItem = styled.div`
  display: grid;
  grid-template-columns: 10vw 1fr;
  align-items: baseline;
  gap: 1vw;
  color: #303030;
`

export const DetailLabel = styled.span`
  font-size: 0.9vw;
  font-weight: 500;
  text-align: left;
  color: #303030;
`

export const DetailValue = styled.span`
  font-size: 0.9vw;
  font-weight: 700;
  text-align: left;
  color: #303030;
`

export const MaintenanceTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5vh;
  color: #303030;
`

export const MaintenanceItemContainer = styled.div`
  border: 1px solid #e0e0e0;
  padding: 2.5vh 1.2vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5vw;
  font-size: 0.9vw;
  color: #303030;
  &:not(:last-child) {
    margin-bottom: 1.5vh;
  }
`

export const HistoryTable = styled(MaintenanceTable)``

export const HistoryItemContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 0.5vw;
  padding: 2.5vh 1.2vw;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5vw;
  font-size: 0.9vw;
  color: #303030;
  &:not(:last-child) {
    margin-bottom: 1.5vh;
  }
`

export const TableCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5vh;
  color: #303030;
`

export const TableCellValue = styled.span`
  font-weight: 700;
  font-size: 0.9vw;
  color: #303030;
`

export const TableCellLabel = styled(DetailLabel)`
  font-size: 0.9vw;
  font-weight: 500;
  white-space: nowrap;
  color: #303030;
`

export const HistoryTableCell = styled(TableCell)``

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2.5vh 1.2vw;
  border-top: 1px solid #e0e0e0;
  color: #303030;
`

export const EditButton = styled.button`
  background-color: #0090d3;
  color: #fff;
  font-size: 0.9vw;
  font-weight: 700;
  padding: 1.75vh 1.5vw;
  border: none;
  border-radius: 2vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5vw;
`

export const AttachmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`

export const AttachmentItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
`

export const AttachmentInfo = styled.span`
  color: #6c757d;
  font-size: 12px;
`

export const AttachmentButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`

export const AttachmentButton = styled.button`
  background: none;
  border: none;
  color: #0090d3;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`

export const EmptyProductsMessage = styled.p`
  grid-column: 1 / -1;
  text-align: center;
  color: #666;
`
